import { addFlagObservation } from "tasks/api"
import updateTaskDetailUseCase from "./updateTaskDetailUseCase"

const deleteObservationUseCase = async (task, message, messageType) => {
    const details = task.detail[messageType] || []
    const observationsAfterDeleted = details.filter(msg => {
        if (msg.id) {
            return msg.id !== message.id
        }

        return msg.date !== message.date
    })

    const {data, detail} = task;
    detail[messageType] = observationsAfterDeleted
    await updateTaskDetailUseCase(data.id, detail)

    return addFlagObservation(data.id, observationsAfterDeleted.length > 0)
}

export default deleteObservationUseCase